<noda-section
  class="mobile-gap"
  [data]="headerData"
>
  <div
    content
    class="conditions__header text-1"
  >
    <noda-translate key="common.best-conditions-v2.description" />
    <b>
      <span>&nbsp;</span>
      <noda-translate key="common.best-conditions-v2.btn" />
    </b>
  </div>
</noda-section>
<div class="conditions">
  <div class="conditions__content">
    <h3 class="conditions__title h3">
      <noda-translate key="common.best-conditions-v2.additional.title" />
    </h3>
    <span class="conditions__text p3">
      <noda-translate key="common.best-conditions-v2.additional.subtitle" />
    </span>
    <ul class="conditions__list">
      @for (item of itemsData; track item) {
        <li class="conditions__item">
          <svg-icon
            name="controls/accept.svg#accept"
            class="conditions__icon"
          />
          <noda-translate
            class="p4"
            [key]="item"
          />
        </li>
      }
    </ul>
  </div>
  <div class="conditions__actions">
    <span class="conditions__description p3">
      <noda-translate key="common.best-conditions-v2.additional.offer" />
    </span>
    <noda-button-v2
      class="conditions__btn"
      [icon]="buttonData.icon"
      [link]="buttonData.link"
      [text]="buttonData.text"
    />
  </div>
</div>
